import api from './api';
import type {
  TenantApplication,
  TenantApplicationPublic,
  TenantApplicationStatus,
  CreateTenantInvitePayload,
  UpdateApplicationStepPayload,
} from '../types/tenantApplication';

// ─── Manager endpoints ────────────────────────────────────────────────────────

export const tenantApplicationsService = {
  createInvite(payload: CreateTenantInvitePayload): Promise<TenantApplication> {
    return api.post('/tenant-applications/invite', payload).then((r) => r.data);
  },

  listApplications(status?: TenantApplicationStatus): Promise<TenantApplication[]> {
    return api
      .get('/tenant-applications', { params: status ? { status } : undefined })
      .then((r) => r.data);
  },

  getApplication(id: number): Promise<TenantApplication> {
    return api.get(`/tenant-applications/${id}`).then((r) => r.data);
  },

  getMyApplication(): Promise<TenantApplication> {
    return api.get('/tenant-applications/mine').then((r) => r.data);
  },

  approve(id: number): Promise<TenantApplication> {
    return api.patch(`/tenant-applications/${id}/approve`).then((r) => r.data);
  },

  reject(id: number, reason: string): Promise<TenantApplication> {
    return api.patch(`/tenant-applications/${id}/reject`, { reason }).then((r) => r.data);
  },

  submitToLandlord(id: number): Promise<TenantApplication> {
    return api.patch(`/tenant-applications/${id}/submit-to-landlord`).then((r) => r.data);
  },

  cancel(id: number): Promise<TenantApplication> {
    return api.patch(`/tenant-applications/${id}/cancel`).then((r) => r.data);
  },

  resend(id: number): Promise<TenantApplication> {
    return api.post(`/tenant-applications/${id}/resend`).then((r) => r.data);
  },
};

// ─── Public endpoints (no JWT) ────────────────────────────────────────────────

export const publicApplicationService = {
  verifyToken(token: string): Promise<TenantApplication & TenantApplicationPublic> {
    return api.get(`/tenant-applications/public/verify/${token}`).then((r) => r.data);
  },

  updateStep(token: string, payload: UpdateApplicationStepPayload): Promise<TenantApplication> {
    return api.patch(`/tenant-applications/public/${token}/step`, payload).then((r) => r.data);
  },

  submit(token: string): Promise<TenantApplication> {
    return api.post(`/tenant-applications/public/${token}/submit`).then((r) => r.data);
  },
};

/** Alias for consumers that import under the public-service name from the spec */
export const tenantApplicationPublicService = publicApplicationService;
